<template>
  <div>
    <modal
      width="660px"
      speed="fast"
      noOutClose
      maskNoClick
      :show="visible"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      @update:show="closeModal(false)"
      class="infoModalContainer">
      <p slot="header" class="header">考试信息</p>
      <div slot="content" class="infoContent">
        <p class="infoText">检测到你的电脑已在本场考试中已参加过考试，请确认是否使用该账号继续答题</p>
        <div class="infoList">
          <span class="infoItem" v-for="(item, idx) in touristsList" :key="idx">
            <span class="infoLabel">{{ item.label }}:</span>
            <span class="infoValue">{{ item.value }}</span>
          </span>
        </div>
      </div>
      <div slot="footer" class="infoBottom">
        <button
          class="createNewBtn"
          @click="createNewTourists">否，生成新账号</button>
        <button
          class="keepGoBtn"
          @click="goAnswerQues">继续答题</button>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal'
import { userIdType, sexType } from '@/views/touristsPage/constant'
import { get, post } from '@/utils/ajax'
import { getTouristsToken, getTouristsVal, removeTouristsToken, removeTouristsUserId, setTouristsUserId } from '@/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const isTourists = getTouristsVal()
    const token = getTouristsToken()
    if (token && isTourists) {
      this.getTouristsMsg()
    }
  },
  computed: {
    ...mapState(['user', 'theme', 'site_msg'])
  },
  data() {
    return {
      touristsList: []
    }
  },
  methods: {
    getLabel(list, val) {
      let _label = ''
      list.map((item) => {
        if (item.value === val) {
          _label = item.label
        }
      })
      return _label
    },
    getCityName() {
      return window.localStorage.getItem('TOURISTSCITY') || ''
    },
    async getTouristsMsg() {
      await get(`/home/submitter/query/${this.theme.id}`).then((data) => {
        this.$emit('setTouristsMsg', true)
        const result = []
        const { submitterInfo, userId } = data
        setTouristsUserId(userId)
        this.$store.dispatch('getTouristsId', userId)
        if (submitterInfo.length > 0) {
          const ignoreList = ['countryId', 'districtId', 'provinceId']
          submitterInfo.map((item) => {
            if (item.checked && !ignoreList.includes(item.bizName)) {
              if (item.inputType === 'TXT' || item.inputType === 'DROP_DOWN_NORMAL') {
                result.push({
                  label: item.showName,
                  value: item.fieldValue
                })
              } else if (item.inputType === 'DROP_DOWN_REGION') {
                result.push({
                  label: item.showName,
                  value: this.getCityName()
                })
              } else if (item.inputType === 'DROP_DOWN_GENDER') {
                result.push({
                  label: item.showName,
                  value: this.getLabel(sexType, item.fieldValue)
                })
              } else if (item.inputType === 'DROP_DOWN_IDTYPE') {
                result.push({
                  label: item.showName,
                  value: this.getLabel(userIdType, item.fieldValue)
                })
              }
            }
          })
          this.touristsList = result
        }
      })
    },
    createNewTourists() {
      this.$emit('setTouristsMsg', false)
      removeTouristsToken()
      removeTouristsUserId()
      this.$router.push({ name: 'touristsmsg',
        query: {
          date: new Date().getTime()
        } })
    },
    async goAnswerQues() {
      this.$emit('close', false)
      await post(`/home/sites/params/auto/arrange`, { address: location.origin + '/' + location.href.split('/')[3], exam_id: localStorage.examId, user_id: this.user.id }, { ignoreTourists: true }).then(() => {
        this.$router.push({ name: 'pretest' })
      })
    },
    closeModal(flag) {
      this.$emit('close', flag)
    }
  }
}
</script>
<style lang="scss" scoped>
.infoModalContainer {
  /deep/.modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .header {
    text-align: center;
  }
  .infoText {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 28px;
    margin-bottom: 10px;
  }
  .infoList {
    min-height: 266px;
    background: #F9F9F9;
    border-radius: 4px;
    padding: 25px 0 25px 30px;
    display: flex;
    flex-wrap: wrap;
    .infoItem {
      width: 45%;
      min-height: 36px;
      display: flex;
      line-height: 36px;
    }
    .infoLabel {
      width: 100px;
      display: inline-block;
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
    }
    .infoValue {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      display: flex;
      flex: 1;
    }
  }
  .infoBottom {
    text-align: center;
    margin-bottom: 50px;
  }
  .createNewBtn {
    @include theme-fill-btn(160px, 42px, 16px, 4px);
    background: #fff;
    box-shadow: none;
    border: 1px solid #A1A1A1;
    margin-right: 20px;
    color: #666666;
    &:hover {
      background: #397EFD;
      box-shadow: 0 6px 12px 0px #397efd4d;
      color: #fff;
      border: 1px solid #397EFD;
    }
  }
  .keepGoBtn {
    @include theme-fill-btn(160px, 42px, 16px, 4px);
  }
}
</style>
